const ENV = {
  NOTIFICATION_DURATION: 3000 // time in ms
}

export const CONTACT_EVENTS = ['contact_mail', 'contact_phone', 'contact_visit']

/**
 * The activity log event names the address book's "journal d'activités"
 * button preselects on the global journal (`TheActivityLogPage.vue`), passed
 * as its `events` query param.
 *
 * Not to be confused with `CONTACT_EVENTS` above: that list names a CRM
 * "customer contact" log (a call, a mail, a visit), unrelated to the
 * `Contact`/`Person` models this one is about.
 */
export const ADDRESS_BOOK_ACTIVITY_LOG_EVENTS = [
  'merge',
  'updated',
  'deleted',
  'archived',
  'unarchived'
]

/**
 * The activity log event names the task dashboard's "journal d'activités"
 * button preselects on the global journal, like the address book's. A deleted
 * task logs the generic `deleted` event, so other deleted records show too.
 */
export const TASK_ACTIVITY_LOG_EVENTS = [
  'add_task_dossier',
  'update_task_dossier',
  'update_task_dossier_status',
  'update_task_dossier_executors',
  'add_task_dossier_executors',
  'deleted'
]

export default ENV
